export const getProductPriceDisplay = (product = {}) => {
  const sellingPrice = Number(product?.price);
  const offerPrice = Number(product?.offerPrice);
  const hasSellingPrice = Number.isFinite(sellingPrice) && sellingPrice > 0;
  const hasOfferPrice = Number.isFinite(offerPrice) && offerPrice > 0;
  const hasDiscount = hasSellingPrice && hasOfferPrice && offerPrice < sellingPrice;
  const customerPrice = hasOfferPrice ? offerPrice : hasSellingPrice ? sellingPrice : 0;

  return {
    customerPrice,
    sellingPrice: hasDiscount ? sellingPrice : null,
    hasDiscount,
  };
};

export const formatInr = (value, options = {}) => {
  const amount = Number(value);

  if (!Number.isFinite(amount)) {
    return options.fallback || "₹0";
  }

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: options.maximumFractionDigits ?? 0,
  }).format(amount);
};
